import messages from "messages";
import { useCallback, ComponentPropsWithoutRef } from "react";
// components
import ConfirmModal from "components/confirm-modal";
import TaskStatus from "../task-status";
// hooks
import useToggleModal from "hooks/useToggleModal";
// constants
import { TASK_TYPES } from "../../constants";

type Props = Pick<
  ComponentPropsWithoutRef<typeof TaskStatus>,
  "tasks" | "show" | "onHide" | "onCancel"
>;
const DownloadTaskStatus = ({ tasks, show, onHide, onCancel }: Props) => {
  const {
    show: showConfirm,
    open: openConfirm,
    close: closeConfirm,
  } = useToggleModal(false);

  const handleHide = useCallback(() => {
    if (tasks.some((el) => el.busy)) {
      return openConfirm();
    }

    return onHide();
  }, [onHide, openConfirm, tasks]);

  return (
    <>
      <TaskStatus
        tasks={tasks}
        show={show}
        onHide={handleHide}
        variant={TASK_TYPES.download}
        onCancel={onCancel}
      />

      {/* confirm remove all tasks, include those in progress */}
      <ConfirmModal
        labelTitle={messages.cancelDownloadAsk}
        children={messages.yourDownloadIsNotComplete}
        labelConfirm={messages.cancelDownload}
        labelCancel={messages.continueDownload}
        show={showConfirm}
        onCancel={closeConfirm}
        onConfirm={() => {
          onHide();
          closeConfirm();
        }}
      />
    </>
  );
};

export default DownloadTaskStatus;
